import React, { useState } from 'react';
import clsx from 'clsx';
import { KpiTable } from '../../../_shared/components/KpiTable/KpiTable';
import { mockKpiItems } from '../../../_shared/mocks';
import { KpiDeletedProps } from '../../../_shared/components/KpiTable/types';
import { Typography } from '../../../_shared/components/Typography/Typography';
import { ReactComponent as ChevronIcon } from '../../../_shared/assets/icons/chevron-down.svg';
import styles from './KpiDeleted.module.scss';

export function KpiDeleted({ isDeleted, onKpiClick }: KpiDeletedProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={styles.deleted}>
      <div className={styles.title} onClick={() => setIsOpen(!isOpen)}>
        <Typography variant={'h6'}>Удаленные КПЭ</Typography>
        <ChevronIcon className={clsx(styles.icon, isOpen && styles.rotated)} />
      </div>

      {isOpen && (
        <KpiTable
          rows={mockKpiItems}
          isDeleted={isDeleted}
          onKpiClick={onKpiClick}
          onEdit={(row) => console.log('edit', row)}
          onDelete={(row) => console.log('delete', row)}
        />
      )}
    </div>
  );
}
